import { defineKind } from "./base";

/** An uploaded video file: the wall's full-screen viewer. A cast queue never holds one. */
export const video = defineKind({
  id: "video",
  types: ["VIDEO"],
  surface: "video",
  icon: "video",
  // Held when hidden, as on Android: a picture never plays unseen (the web viewer has no hidden state today).
  caps: { seekable: true, endsByItself: true, heldWhenHidden: true, gallery: true, fullScreen: true },
  label: (t) => t("wall_item_video", "Video"),
  meta: (t) => t("wall_video", "Video"),
  typeLabel: (t) => t("wall_item_video", "Video"),
});
